import React from 'react';
import { config } from "../config";

class Iframepoc extends React.Component {

    constructor(props) {
        super(props);
        this.widgetCreated = false;
    }

    iframeWidget() {
        if(this.widgetCreated) return;

        // START EMBEDDABLE SCRIPT: <script type="text/javascript">
        // document.addEventListener("DOMContentLoaded", function() {
            var compareElemId = "compareWidget",
                origin = config.IFRAME_ORIGIN,
                path = "",
                compareElem = document.getElementById(compareElemId),
                iframe,
                barHtml,
                buttonBarElem,
                buttonBarId = "compareWidgetButtonBar",
                buttonBarStyles,
                backButtonId = "compareWidgetBackButton",
                backButtonStyles,
                nextButtonId = "compareWidgetNextButton",
                nextButtonStyles,
                hoverStyles,
                mediaQueryStyles,
                phase,
                hash,
                height,
                source;
            if(compareElem) {
                // Get current hashbang url when landed here and set it to iframe src path
                hash = window.location.hash;
                if(hash) path = hash.split('|')[0].replace("#", "");
                // Add event listener for messages incoming from iframe
                window.addEventListener("message", function(e) {
                    if(e.origin === origin) {
                        if(!source) {
                            source = e.source;
                            source.postMessage({
                                "hash": true,
                                "curHash": hash.replace("#","")
                            }, origin);
                        }
                        phase = e.data["phase"];
                        height = e.data["height"];
                        iframe.style.height = (height + 100) + "px";
                        iframe.style.transition = "height 0.2s ease-in-out";
                        hash = "#" + phase;
                        if(window.history.pushState) {
                            window.history.pushState(null, null, hash);
                        } else {
                            window.location.hash = hash;
                        }
                        nextButtonStateCheck();
                        if(e.data["debug"]) {
                            console.log("PHASE",phase);
                            console.log("HEIGHT",height);
                            console.log(e);
                        }
                    }
                });

                // Create iframe elem and append it to compareWidget
                iframe = document.createElement("iframe");
                iframe.setAttribute("id", compareElemId + "Iframe");
                iframe.setAttribute("src", origin + "/" + path + hash);
                iframe.setAttribute("style", "width:100%;border:none;min-height:800px;");
                compareElem.appendChild(iframe);

                buttonBarStyles = "width:100%;"+
                    "max-width:1097px;"+
                    "height:78px;"+
                    "background-color:#fff;"+
                    "border-top:1px solid #D2D2D2;"+
                    "position:fixed;"+
                    "bottom:0;"+
                    "left:50%;"+
                    "z-index:1000;"+
                    "padding:0 25px;"+
                    "font-family:'NeueHaasGroteskText Pro', sans-serif;"+
                    "transform:translateX(-50%);";
                backButtonStyles = "border:none;"+
                    "background:none;"+
                    "outline:none;"+
                    "cursor:pointer;"+
                    "color:#000;"+
                    "font-size:16px;"+
                    "float:left;"+
                    "margin-top:27px;"+
                    "margin-left:27px;"+
                    "display:none;"+
                    "transition:color 0.2s ease-in-out;"+
                    "line-height:1;";
                nextButtonStyles = "background-color:#F3F3F3;"+
                    "color:#000;"+
                    "font-weight:bold;"+
                    "float:right;"+
                    "padding:12px 40px;"+
                    "display:block;"+
                    "margin-top:20px;"+
                    "margin-right:calc(29% + 40px);"+
                    "cursor:default;"+
                    "font-size:1.6rem;"+
                    "-webkit-font-smoothing:antialiased;"+
                    "border:1px solid #D2D2D2;"+
                    "border-radius:4px;"+
                    "outline:none;"+
                    "transition:background-color 0.2s ease-in-out, color 0.2s ease-in-out;"+
                    "line-height:1;";
                hoverStyles = "#"+backButtonId+":hover{color:#00584D !important;}#"+nextButtonId+":hover:not(:disabled){background-color:#ff5f0d !important;}";
                mediaQueryStyles = "@media (max-width:1128px){#"+buttonBarId+"{margin-left:0 !important;}} "+
                    "@media (max-width:991px){#"+nextButtonId+"{margin-right:0 !important;}#"+backButtonId+"{margin-left:0 !important;}}"+
                    "@media (max-width:500px){#"+backButtonId+"{max-width:150px;text-align:left;margin-top:20px !important;}}";
                barHtml = '<div id="'+buttonBarId+'" style="'+buttonBarStyles+'">'+
                    '<button id="'+backButtonId+'" style="'+backButtonStyles+'">Palaa edelliseen vaiheeseen</button>'+
                    '<button id="'+nextButtonId+'" style="'+nextButtonStyles+'">Jatka</button>'+
                    '<style>'+hoverStyles+mediaQueryStyles+'</style>'+
                '</div>';

                compareElem.style.position = "relative";
                compareElem.insertAdjacentHTML('beforeend', barHtml);
                document.getElementById(nextButtonId).onclick = nextClick;
                document.getElementById(backButtonId).onclick = backClick;
                buttonBarElem = document.getElementById(buttonBarId);
                window.addEventListener('scroll', function(e) {
                    let wHeight = window.innerHeight,
                        compareBottom = compareElem.getBoundingClientRect().bottom;
                    if(compareBottom - wHeight < 0) {
                        buttonBarElem.style.position = "absolute";
                    } else {
                        buttonBarElem.style.position = "fixed";
                    }
                });
            }
            function backClick(e) {
                if(source) {
                    source.postMessage({
                        "back": true,
                        "curPhase": phase.split("|")[0].replace("phase","")
                    }, origin);
                    window.scrollTo(0,225);
                }
            }
            function nextClick(e) {
                if(source) {
                    source.postMessage({
                        "next": true,
                        "curPhase": phase.split("|")[0].replace("phase","")
                    }, origin);
                    window.scrollTo(0,225);
                }
            }
            function setNextButtonActive() {
                let next = document.getElementById(nextButtonId);
                next.style.display = "inline-block";
                next.style.backgroundColor = "#FF8140";
                next.style.color = "#FFF";
                next.style.cursor = "pointer";
                next.style.border = "1px solid transparent";
                next.style.visibility = "visible";
                next.removeAttribute("disabled");
            }
            function setNextButtonDisabled() {
                let next = document.getElementById(nextButtonId);
                next.style.display = "inline-block";
                next.style.backgroundColor = "#F3F3F3";
                next.style.color = "#000";
                next.style.cursor = "default";
                next.style.border = "1px solid #D2D2D2";
                next.setAttribute("disabled", "disabled");
            }
            function nextButtonStateCheck() {
                let p = phase.split("|");
                switch(p[0]) {
                    case "phase1":
                        document.getElementById(backButtonId).style.display = "none";
                        if(p[1] !== "" && p[1] !== "null") {
                            setNextButtonActive();
                        } else {
                            setNextButtonDisabled();
                        }
                        break;
                    case "phase2":
                    case "phase3":
                        document.getElementById(backButtonId).style.display = "inline-block";
                        if(p[2] !== "") {
                            setNextButtonActive();
                        } else {
                            setNextButtonDisabled();
                        }
                        break;
                    case "phase4":
                        document.getElementById(backButtonId).style.display = "inline-block";
                        document.getElementById(nextButtonId).style.visibility = "hidden";
                        setNextButtonDisabled();
                        break;
                    default:
                        break;
                }
            }
        // });
        // END EMBEDDABLE SCRIPT: </script>
        // ALSO ADD HTML: <div id="compareWidget"></div>

        // Teaser box:
        // <iframe src="https://db7tuc0572rln.cloudfront.net/#teaserbox" style="width:100%;height:493px;box-shadow: 0 2px 4px 0 rgba(0,0,0,0.5);">

        this.widgetCreated = true;
    }

    componentDidMount() {
        if(this.props.state.iframe !== 999) {
            this.props.updateState({
                iframe: true
            });
        }
        this.iframeWidget();
    }

    render() {
        return (
            <div id="compareWidget"></div>
        );
    }
}

export default Iframepoc;